import React from 'react';

import { Inbox, Loader2, PauseCircle, Plus } from 'lucide-react';

import Link from 'common/Link';
import ButtonV2 from 'common/ui/ButtonV2';

import AdminQueueNUX from './AdminQueueNUX';

import type { Company } from 'common/api/endpoints/companies';

type Props = {
  company: Company;
};

const AutopilotNUX = ({ company }: Props) => {
  const { installedSyncIntegrations } = company;

  // no sources installed
  if (installedSyncIntegrations.length === 0) {
    return (
      <AdminQueueNUX
        cta={
          <Link to="/admin/settings/autopilot/feedback-discovery">
            <ButtonV2 startIcon={Plus} size="medium">
              Connect source
            </ButtonV2>
          </Link>
        }
        icon={Inbox}
        info={[
          'Your inbox is currently empty. Connect a source to automatically import relevant feedback into your Canny workspace.',
        ]}
        title="Connect a source"
      />
    );
  }

  if (installedSyncIntegrations.filter((integration) => !integration.disabled).length === 0) {
    return (
      <AdminQueueNUX
        cta={
          <Link to="/admin/settings/autopilot/feedback-discovery">
            <ButtonV2 startIcon={PauseCircle} size="medium">
              Enable sources
            </ButtonV2>
          </Link>
        }
        icon={Inbox}
        info={[
          'All of your connected sources are currently disabled. Enable them to resume feedback extraction and processing',
        ]}
        title="Enable your sources"
      />
    );
  }

  return (
    <AdminQueueNUX
      cta={
        <Link to="/admin/settings/autopilot/feedback-discovery">
          <ButtonV2 startIcon={Plus} size="medium">
            Connect more sources
          </ButtonV2>
        </Link>
      }
      loading={true}
      icon={Loader2}
      info={[
        'Canny Autopilot is working hard to extract and process all of the feedback from your sources. Check back in a few hours.',
      ]}
      title="Preparing your inbox..."
    />
  );
};

export default AutopilotNUX;
